import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Container from 'reactstrap/lib/Container';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { LeaseDealsModel, LeaseDealsPaths } from 'client/data/models/lease-deals';
import { getQuery } from 'client/utils/location';
import { PreviewCard } from './preview-card';
import { PreviewEmpty } from './preview-empty';

import './lease-deal-preview.scss';

const PREVIEW_CREATIVE_ID = 'edm-lease-deals-preview';
const INVALID_DEAL_CREATIVE_ID = 'edm-lease-deals-invalid-deal';

function LeaseDealPreviewComponent({ deal = undefined }) {
  const isMobile = useSelector(state => state.mobile);

  return (
    <section
      id="lease-deals-preview"
      className="lease-deal-preview pb-1_5 pt-2 pt-md-1_5 pos-r z-1"
      data-tracking-parent={deal === null ? INVALID_DEAL_CREATIVE_ID : PREVIEW_CREATIVE_ID}
    >
      <Container>{deal ? <PreviewCard deal={deal} isMobile={isMobile} /> : <PreviewEmpty />}</Container>
    </section>
  );
}

LeaseDealPreviewComponent.propTypes = {
  deal: PropTypes.shape({}),
};

const stateToPropsConfig = {
  deal: bindToPath(
    props => {
      const rawId = getQuery(props.location).id;
      const id = Array.isArray(rawId) ? rawId[0] : rawId;

      return id ? LeaseDealsPaths.getSelectedDealPath(id) : undefined;
    },
    LeaseDealsModel,
    undefined,
    false
  ),
};

export const LeaseDealPreview = withRouter(connectToModel(LeaseDealPreviewComponent, stateToPropsConfig));
